export default __webpack_public_path__ + "static/media/worker-default-photo.e4ce0ce6.png";